// extracted by mini-css-extract-plugin
export default {"title":"quick-charge-method-modal_title__RJReu","options":"quick-charge-method-modal_options__pl0tv","option":"quick-charge-method-modal_option__SYkpD"};